// extracted by mini-css-extract-plugin
module.exports = {"container":"loyalty-status_container__l_bJD","visible":"loyalty-status_visible__4LoJR"};